import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { GetSalesOrganizationParams } from './types'
import type { SalesOrganizationDto } from './dtos'

const URL = '/location/sales-organizations/'

export const getSalesOrganization: AblePaginatedResponseFn<
GetSalesOrganizationParams,
SalesOrganizationDto
> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
